
import { useState } from 'react';
import MarketingBanner from './components/MarketingBanner';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import ClassesSection from './components/ClassesSection';
import TeachersSection from './components/TeachersSection';
import NewsletterSection from './components/NewsletterSection';
import Footer from './components/Footer';

const HomePage = () => {
  const [showBanner, setShowBanner] = useState(true);

  return (
    <div className="min-h-screen bg-white">
      {showBanner && <MarketingBanner onClose={() => setShowBanner(false)} />}
      <HeroSection />
      <FeaturesSection />
      <ClassesSection />
      <TeachersSection />
      <NewsletterSection />
      <Footer />
    </div>
  );
};

export default HomePage;
